import { AutomedDoctorAvailabilityTimeModel } from '../availability';
import { ServiceType } from 'src/utils/serviceTypes';

export interface BookingUserProfileModel {
    userId: string;
    siteId: number;
    bpUserId: string;
    username: string;
    automedDisplayName: string;
    firstname: string;
    surname: string;
    umbracoProfileUrl: string;
    automedProfileUrl: string;
    siteName: string;
    locationName: string;
    gender: string;
    aboutInHTML: string;
    isNurseOrDoctor: boolean;
    sortOrder: number;
    umbracoRole: string;
    umbracoQualification: string;
    umbracoPageUrl: string;
    umbracoLanguages: string[];
    noNewPatient: boolean;
    myPatient: boolean;
    enableDoctorNotice: boolean;
    doctorNotice?: string;
    inIsolation: boolean;
    inIsolationDate?: string;
    apptTypeIds: number[];
    displayProfileNoOnlineBooking: boolean;
}

export interface UmbracoClinicModel {
    /** @deprecated Represents Umbraco ID, not ERP */
    id: number;
    name: string;
    state: string;
    addressHtml: string;
    phoneNumber: string;
    url: string;
    imageUrl: string;
    latitude: number;
    longitude: number;
    ianaTimeZoneId: string;
    openingHours: UmbracoOpeningHours[];
    specialHours: UmbracoSpecialOpeningHours[];
    cancellationTitle: string;
    cancellationPolicyHtml?: string;
    isAfterHoursServiceAvailable: boolean;
    afterHoursServiceTitle: string;
    afterHoursServiceContentHtml: string;
    afterHoursServiceDisabledContentHtml: string;
    pricingElements: PricingElement[];
    clinicServiceTypes: UmbracoClinicServiceType[];
}

export interface UmbracoOpeningHours {
    /** @deprecated */
    dayOfTheWeek: string;
    /** 1 - 7, Mon - Sun */
    dayOfWeek: number;
    dayName: string;
    shortDayName: string;
    openingTime: string;
    closingTime: string;
    date?: string;
    dateString?: string;
    isCurrentDay?: string;
}

export interface UmbracoSpecialOpeningHours {
    title: string;
    date: string;
    openingTime: string;
    closingTime: string;
    dayName: string;
    shortDayName: string;
    dateString: string;
}

export interface PricingElement {
    title: string;
    contentHtml: string;
}

export interface UmbracoClinicServiceType {
    label: string;
    serviceTypes: UmbracoAutomedServiceType[];
}

export interface UmbracoAutomedServiceType {
    id: ServiceType;
    name: string;
}

export interface BookingRequest {
    BPUserId: number;
    Date: string;
    AppointmentTypeId: number;
    Duration: number;
    PatientName: string;
    AppointmentComment?: string;
    AutomedTime: AutomedDoctorAvailabilityTimeModel;
    BookingService?: BookingServiceSource;
    AppointmentServiceType: AppointmentServiceType;
}

export interface TelehealthBookingRequest extends BookingRequest {
    TimeSlotId: number;
}

export interface AutomedBookingRequestResponse {
    appointment_id: number;
    message: string;
    clinic_group_crm: number;
    user_fk: number;
    location_id: number;
    doctor_id: number;
    patient_id: number;
    video_room_number?: string;
    video_url?: string;
}
export interface DuplicateBookingsResponse {
    status: string;
    duplicates: DuplicateBookingDetails[];
}
export interface DuplicateBookingDetails {
    appointment_id: number;
    appointment_type_name: string;
    appointment_type_id: number;
    doctor_full_name: string;
    doctor_id: number;
    date: string;
    time: string;
    manage_booking_url?: string;
}

export interface GeoCoordinate {
    latitude: number;
    longitude: number;
}

export enum BookingServiceSource {
    MyhealthBooking = 'MyhealthBooking',
    TelehealthNow = 'TelehealthNow',
    PatientPortal = 'PatientPortal',
}

export enum AppointmentServiceType {
    FaceToFace = 'FaceToFace',
    Telehealth = 'Telehealth',
    AfterHours = 'AfterHours',
    ExpressTelehealth = 'ExpressTelehealth',
}

export interface BookingConfirmationRequest {
    sendSMS: boolean;
    doctorProfileUrl: string;
    patientEmail?: string;
    patientMobile?: string;
    patientFullName: string;
    appointmentServiceType: AppointmentServiceType;
    appointmentDuration: string;
    clinicName: string;
    clinicAddress: string;
    clinicAddressUrl: string;
    clinicTel: string;
    clinicGeoCoordinate: GeoCoordinate;
    doctorFullName: string;
    appointmentTypeName: string;
    appointmentDate: string;
    appointmentTime: string;
    appointmentDateTimeUTC: string;
    paymentId?: string;
}

export interface AppointmentByHash {
    /** @deprecated Use user_id instead */
    doctor_id: number;
    user_id: number;
    date: string;
    time: string;
    account_type: number;
    appointment_id: number;
    appointment_type_name: string;
    can_be_cancelled: boolean;
    appointment_type_id: number;
    location_id: number;
    doctor_full_name: string;
    appointment_code: number;
}

export type AutomedPaymentResult = {
    status: number;
    msg: string;
    error?: string;
    payment_id?: string;
};
